import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

/**
 * Created by Ning Jiang on 11/24/2016.
 */

export class WGSoundConfig implements ISoundConfig {

    public static instance: WGSoundConfig = new WGSoundConfig();


    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig"

    // background
    MAIN_GAME_AMBIANCE_1: string = "background-music-main";
    FREE_GAME_AMBIANCE: string = "background-music-fs";
    SUPER_FREE_GAME_AMBIANCE: string = "background-music-super-fs";
    BACKGROUND_RAIN: string = "rain";
    BACKGROUND_THUNDER: string = "thunder"

    // reel sounds
    REELS_SPINNING: string = "reelsSpinning";
    SPIN_START_FS: string = "spinStartFs"
    REELS_DEFAULT_BOUNCE: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5", "reelLanding6"];

    // win sounds
    INITIAL_WIN_SOUNDS: string[] = ["winTiny", "winSmall", "winMedium", "winLarge"];
    WA_INITIAL_WIN_SOUND: string = "waInitialWinSweep";
    INITIAL_WIN_SCATTER_SOUND: string = "winlineScatter";
    COUNTUP_SOUND: string = "countup" // to play in loop when we play countup
    COUNTUP_END: string = "countupEnds" // to play when show final coutup amount except in tiny
    COUNTUP_END_TINY: string = "countupEndsTiny" // to play when show tiny win amount

    MULTIPLIER_COUNTUP: string[] = ["countupMultiplier1", "countupMultiplier2", "countupMultiplier3", "countupMultiplier4"];
    MULTIPLIER_COUNTUP_END: string = "countupMultiplierEnds" // to play when show tiny win amount

    //scatterSounds
    SCATTER_BOUNCE_SOUNDS: string[] = ["scatter1", "scatter2", "scatter3"];
    SCATTER_ANTICIPATION: string = "scatterAnticipation";
    SCATTER_ANTICIPATION_FIRE: string = "scatterAnticipationFire";
    SCATTER_ANTICIPATION_END_WIN: string = "scatterAnticipationEndsWin";
    SCATTER_ANTICIPATION_END_FAIL: string = "scatterAnticipationEndsFail";
    SCATTER_HIGHLIGHT: string = "scatterHighlight";

    // intro Sounds
    FS_INTRO: string = "fsIntro";
    FS_INTRO_EXPLODE: string = "fsIntroExplode";

    //superfsIntro
    SUPER_FS_TRANSITION: string = "superFSTransition";

    // wild sounds
    WILD_LANDING: string = "wildLanding";
    WILD_NUDGE_WIN: string[] = ["wildNudgeX2", "wildNudgeX3"];
    WILD_NO_NUDGE: string = "wildX1"
    WILD_CHAIN: string = "wildChain";

    // outro Sound
    FS_END = "fsEnds";
    FS_END_NOWIN = "fsEndsNoWin";
    FS_OUTRO_STONE_COMING = "fsOutroGravestone";
    FS_OUTRO_STONE_COMING_NO_WIN = "fsOutroGravestoneNoWin";
    FS_OUTRO_STONE_DOWN = "fsOutroGravestoneDown";

    //fs Sounds
    FS_PLUS_ONE:string = "fsPlusSpin";
    FS_FIRE_BALL:string = "fireBall";


    // warrior attack feaure sounds sounds
    WARRIOR_LANDING: string = "waMidLanding";
    WARRIOR_ANTICIPATON: string = "waAnticipation";
    WARRIOR_ANTICIPATON_FAIL: string = "waAnticipationEndsFail";
    WARRIOR_ANTICIPATON_WIN: string = "waAnticipationEndsWin";
    WARRIOR_NUDGE: string = "waMidNudge";
    WARRIOR_MOVING_LEFT: string = "waMidMoveLeft";
    WARRIOR_ALIVE_SWEEP: string = "waSymbolsSweep";
    WARRIOR_BETLINE_SOUND: string = "waBetlineCountup";

    // continue button sounds
    CONTINUE_BUTTON_SOUND: string = "continueButton";

    // bigwinSounds
    BIG_WIN_INITIAL_WIN_SOUND: string = "bigwinInitialWin";
    BIG_WIN_LEVEL_SOUNDS: string[] = ["bigwinLevel1", "bigwinLevel2", "bigwinLevel3", "bigwinLevel4", "bigwinLevel5"];
    BIG_WIN_ENDS: string = "bigwinEnds";
    BIG_WIN_ANTICIPATION: string = "bigwinAnticipation";

    constructor() {
        if (WGSoundConfig.instance) {
            throw new Error("WGSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}